<form (submit)="submitForm()" [formGroup]="restoreForm" class="auth-form">
    <lta-btn class="auth-form__back" routerLink="../" size="md" theme="secondary">
        <lta-svg-icon icon="back" size="20"></lta-svg-icon>
    </lta-btn>
    <i class="auth-form__icon">
        <lta-logo [type]="'login'"></lta-logo>
    </i>
    <div class="auth-form__subtitle">{{'lta-login.changePasswordMessage' | translate}}</div>
    <div class="auth-form__input-group">
        <lta-input
                formControlName="newPassword"
                icon="lock"
                label="{{ 'lta-login.newPassword' | translate }}"
                placeholder="{{ 'lta-login.newPassword' | translate }}"
                type="password">
        </lta-input>
        <lta-input
                formControlName="repeatPassword"
                icon="lock"
                label="{{ 'lta-login.repeatThePassword' | translate }}"
                placeholder="{{ 'lta-login.repeatThePassword' | translate }}"
                type="password">
        </lta-input>
    </div>
    <lta-btn class="auth-form__btn" size="lg" theme="primary">
		<span>{{ 'lta-login.logIn' | translate }}
            <lta-svg-icon icon="arrow-right" size="20"></lta-svg-icon>
		</span>
    </lta-btn>
</form>
